import { rem } from "@mantine/core";
import type { DiscoverPromoSlide } from "@shared/discoverPromoSlide";

import { CONTENT_MAX_WIDTH } from "@/shared/constants/layout.constants";

/** Shared content column — matches LandingNavbar maxWidth. */
export const DISCOVER_PAGE_CONTENT_SIZE = CONTENT_MAX_WIDTH;
/** Shared horizontal inset — matches LandingNavbar padding `0 20px`. */
export const DISCOVER_PAGE_CONTENT_PX = { base: 16, sm: 20 } as const;

export const DEFAULT_PAGE_SIZE = 10;
export const AUTH_DISCOVER_PAGE_SIZE = 12;
export const DISCOVER_PAGE_SIZE_OPTIONS = [4, 8, 12, 16, 20, 24] as const;

export { COMPACT_COMPANY_GRID_COLS } from "./companyGridPageSize.util";
export const LOADER_SHOW_DELAY_MS = 150;
export const LOADER_MIN_VISIBLE_MS = 320;

/** Delay before `quickSearch` / browse+AI fetch runs while the user types in the keyword field. */
export const QUICK_SEARCH_DEBOUNCE_MS = 700;

/** Space under scrollable content so the last cards clear the fixed mobile promo strip. */
export const MOBILE_PROMO_STRIP_RESERVE = rem(200);

/** Approx. mobile strip height (paper vertical padding + carousel) for dock sentinel math. */
export const MOBILE_PROMO_STRIP_PX = 150;

export const MAX_RETRIES = 2;

export const DEFAULT_DISCOVER_PROMO_SLIDES: DiscoverPromoSlide[] = [
  {
    id: "promo-collab-india-china",
    flags: ["IN", "CN"],
    headline: "Recent collaboration",
    description: "Indian and Chinese collaboration made!",
  },
  {
    id: "promo-collab-poland-vietnam",
    flags: ["PL", "VN"],
    headline: "Recent collaboration",
    description: "Poland and Vietnamese collaboration made!",
  },
  {
    id: "promo-collab-turkey-united-states",
    flags: ["TR", "US"],
    headline: "Recent collaboration",
    description: "Turkish and United States collaboration made!",
  },
  {
    id: "promo-collab-egypt-uae-textile-fashion",
    flags: ["EG", "AE"],
    headline: "Recent Collaboration",
    description: "Egyptian Textile Manufacturer and UAE Fashion Distributor",
  },
  {
    id: "promo-collab-uk-india-renewable-solar",
    flags: ["GB", "IN"],
    headline: "Recent Collaboration",
    description: "United Kingdom Renewable Energy Facilitator and Indian Solar EPC Company",
  },
];
